import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerNomineDelegheConservazioneModalComponent} from './worker-nomine-deleghe-conservazione-modal';

export const WorkerNomineDelegheConservazioneModalModule: string = ng
    .module('worker-nomine_deleghe_conservazione-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerNomineDelegheConservazioneModalComponent', WorkerNomineDelegheConservazioneModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-nomine-deleghe-conservazione-modal/worker-nomine-deleghe-conservazione-modal.module.ts